import React, { useState } from "react";
import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Stack,
    Typography,
} from "@mui/material";

import SendIcon from "@mui/icons-material/Send";
import AlertMessage from "../../../Common/Alert/AlertMessage";
import FormBuilder from "../../../Common/FormBuilder/FormBuilder";
import { formStatusMessage } from "../Appraisal/AppraisalFunctions";

const SurveyWrapper = ({
    container = "",
    title = "",
    subheader = "",
    data = {},
    onSubmit = null,
    isAppraiser = false,
}) => {
    const status = data?.status ?? "";
    const form = data?.form ?? null;

    const messageStatus = !data?.id ? "no_data" : status;
    const alert = formStatusMessage(container, messageStatus, isAppraiser);

    const [params, setParams] = useState(
        form?.elements?.reduce(
            (acc, curr) => ({ ...acc, [curr.name]: curr.response }),
            {}
        )
    );

    const onFormFieldChange = ({ elements }) => {
        const question = elements[0];
        setParams({ ...params, [question.name]: question.response });
    };

    const canSubmit = form?.elements?.every(
        (el) => !el.isRequired || !!params[el.name]
    );

    return (
        <Card className="card">
            <CardHeader
                disableTypography={true}
                title={
                    <Typography component="h2" className="card-header-title">
                        {title}
                    </Typography>
                }
                subheader={
                    <Typography
                        component="span"
                        className="card-header-subtitle"
                    >
                        {subheader}
                    </Typography>
                }
                action={
                    <Stack
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={2}
                        sx={{ padding: "8px" }}
                    >
                        {canSubmit && (
                            <Button
                                variant="contained"
                                color="primary"
                                disableElevation={true}
                                aria-label="Submit"
                                onClick={() => onSubmit(params)}
                                endIcon={<SendIcon />}
                            >
                                Submit
                            </Button>
                        )}
                    </Stack>
                }
            />

            {alert?.message && (
                <CardContent>
                    <Box className="card-content">
                        <AlertMessage
                            severity={alert.severity}
                            message={alert.message}
                        />
                    </Box>
                </CardContent>
            )}
            {form?.elements && (
                <CardContent>
                    <Box className="card-content">
                        <FormBuilder
                            form={form}
                            canUpdate={data?.canUpdate}
                            onFieldChange={onFormFieldChange}
                        />
                    </Box>
                </CardContent>
            )}
            {canSubmit && (
                <CardActions className="card-actions">
                    <Stack
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="center"
                        spacing={2}
                        sx={{ padding: "8px" }}
                    >
                        <Button
                            variant="contained"
                            color="primary"
                            disableElevation={true}
                            aria-label="Submit"
                            onClick={() => onSubmit(params)}
                            endIcon={<SendIcon />}
                        >
                            Submit
                        </Button>
                    </Stack>
                </CardActions>
            )}
        </Card>
    );
};

export default SurveyWrapper;
